import React from 'react';
import { Link } from 'react-router-dom';
import { useAdmin } from '../contexts/AdminContext';

const CITY_LINKS = [
  { name: 'Taxi La Grand-Croix', slug: '/taxi-la-grand-croix' },
  { name: 'Taxi Rive-de-Gier', slug: '/taxi-rive-de-gier' },
  { name: 'Taxi Saint-Étienne', slug: '/taxi-saint-etienne' },
  { name: 'Taxi Lorette', slug: '/taxi-lorette' },
  { name: "Taxi L'Horme", slug: '/taxi-l-horme' },
  { name: 'Taxi Saint-Chamond', slug: '/taxi-saint-chamond' },
  { name: 'Taxi Mornant', slug: '/taxi-mornant' },
  { name: 'Taxi Givors', slug: '/taxi-givors' },
  { name: 'Taxi Lyon', slug: '/taxi-lyon' }
];

const SERVICE_LINKS = [
  { name: 'Navette Aéroport', slug: '/navette-aeroport' },
  { name: 'Taxi Aéroport Lyon', slug: '/taxi-aeroport-lyon' },
  { name: 'Taxi Aéroport Saint-Étienne', slug: '/taxi-aeroport-saint-etienne-boutheon' },
  { name: 'Transport Médical', slug: '/transport-medical' },
  { name: 'Taxi de Nuit', slug: '/taxi-nuit' },
  { name: 'Taxi Gare', slug: '/taxi-gare' },
  { name: 'Course Urgente', slug: '/course-urgente' },
  { name: 'Hôpitaux Stéphanois', slug: '/hopitaux-stephanois' },
  { name: 'Hôpitaux Lyonnais', slug: '/hopitaux-lyonnais' },
  { name: 'Taxi Stations de Ski', slug: '/taxi-stations-ski' }
];

function Footer() {
  const { settings } = useAdmin();
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="footer"
      itemScope
      itemType="https://schema.org/Organization"
      aria-label="Pied de page"
    >
      <div className="container">
        <div className="footer-content">

          {/* Colonne 1 : Société */}
          <div className="footer-section footer-about">
            <div className="footer-brand">
              <span className="footer-logo-mark" aria-hidden="true">T</span>
              <p className="footer-brand-name" itemProp="name">{settings.companyName || 'TAXI ABEL'}</p>
            </div>
            <p itemProp="description">
              {settings.companySlogan || 'Service de taxi professionnel basé à La Grand-Croix (42320), desservant toute la vallée du Gier, Saint-Étienne, Rive-de-Gier, Lyon et les aéroports, gares et hôpitaux de la région.'}
            </p>
            <div className="footer-contact-block" itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
              <p>
                <strong>📍 Base :</strong>{' '}
                <span itemProp="streetAddress">{settings.address || 'La Grand-Croix'}</span>,{' '}
                <span itemProp="postalCode">42320</span>{' '}
                <span itemProp="addressLocality">La Grand-Croix</span>
              </p>
              <p>
                <strong>📞 Tél :</strong>{' '}
                <a href={`tel:${settings.phone || '+33477123456'}`} itemProp="telephone">
                  {settings.phone || '04 77 12 34 56'}
                </a>
              </p>
              <p>
                <strong>✉️ Email :</strong>{' '}
                <a href={`mailto:${settings.email || 'contact@taxiabel.fr'}`} itemProp="email">
                  {settings.email || 'contact@taxiabel.fr'}
                </a>
              </p>
              <p>
                <strong>💬 WhatsApp :</strong>{' '}
                <a href={`https://wa.me/${(settings.phone || '+33477123456').replace(/[^\d]/g, '')}`} target="_blank" rel="noopener noreferrer">
                  Envoyer un message
                </a>
              </p>
            </div>
            <p className="footer-hours">
              <strong>🕐 Disponibilité :</strong> 24h/24, 7j/7 — jours fériés inclus
            </p>
          </div>

          {/* Colonne 2 : Villes */}
          <div className="footer-section">
            <h3>Taxi par ville</h3>
            <nav aria-label="Liens villes">
              <ul className="footer-links">
                {CITY_LINKS.map((link, i) => (
                  <li key={i}>
                    <a href={link.slug}>{link.name}</a>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          {/* Colonne 3 : Services */}
          <div className="footer-section">
            <h3>Nos services</h3>
            <nav aria-label="Liens services">
              <ul className="footer-links">
                {SERVICE_LINKS.map((link, i) => (
                  <li key={i}>
                    <a href={link.slug}>{link.name}</a>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          {/* Colonne 4 : Infos légales */}
          <div className="footer-section">
            <h3>Informations légales</h3>
            <ul className="footer-legal">
              {settings.siren && <li><strong>SIREN :</strong> {settings.siren}</li>}
              {settings.siret && <li><strong>SIRET :</strong> {settings.siret}</li>}
              {settings.rcs && <li><strong>RCS :</strong> {settings.rcs}</li>}
              {settings.tva && <li><strong>TVA :</strong> {settings.tva}</li>}
              {settings.capital && <li><strong>Capital :</strong> {settings.capital}</li>}
              {!settings.siren && (
                <>
                  <li><strong>Artisan :</strong> Taxi agréé</li>
                  <li><strong>Région :</strong> Auvergne-Rhône-Alpes</li>
                  <li><strong>Département :</strong> Loire (42)</li>
                </>
              )}
            </ul>
            <div className="footer-tariff-info">
              <h4>Tarifs officiels Loire</h4>
              <p>Arrêté préfectoral n° 57-DDPP-2025 du 18/02/2025</p>
              <ul>
                <li>Prise en charge : 3,10 €</li>
                <li>Tarif jour : 2,18 €/km</li>
                <li>Tarif nuit : 3,27 €/km</li>
                <li>Minimum : 8,00 €</li>
              </ul>
            </div>
            <div className="footer-nav-links">
              <Link to="/">Accueil</Link>
              <Link to="/calculateur">Calculateur</Link>
              <Link to="/blog">Blog &amp; conseils</Link>
              <Link to="/politique-de-confidentialite">Politique de confidentialité</Link>
            </div>
            <Link to="/calculateur" className="footer-cta-btn">
              Estimer ma course
            </Link>
          </div>

        </div>

        <div className="footer-bottom">
          <p>© {currentYear} {settings.companyName || 'TAXI ABEL'} — Taxi professionnel La Grand-Croix (Loire 42). Tous droits réservés.</p>
          <p className="footer-legal-links">
            <Link to="/politique-de-confidentialite">Politique de confidentialité</Link>
            <span aria-hidden="true"> · </span>
            <span>SIREN 919 966 374</span>
          </p>
          <p className="footer-tagline">
            Service de taxi 24h/7j | Vallée du Gier | Saint-Étienne | Rive-de-Gier | Aéroport Lyon | Transport médical
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
